module.exports = __webpack_public_path__ + "static/media/join_franchisee.b002a6fa.svg";